import { Component, OnInit } from '@angular/core';
import {AccountService} from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { Account } from '../models/account';
import { ServiceProviderService } from '../services/service-provider/service-provider.service';

@Component({
  selector: 'app-provider-configuration',
  templateUrl: './provider-configuration.component.html',
  styleUrls: ['./provider-configuration.component.css']
})
export class ProviderConfigurationComponent implements OnInit {

  accounts : Account[]=[];
  accountId : number=0;
  screeningCenters : any[]=[];
  providers : any[]=[];
  resetPage : boolean = false;
  //screeningCenterIds : Number[]=[];
  dataObject : any[]=[];
  dataObjectCopy : any[]=[];
  showEyeNukPanel:Boolean=false;
  camera_token=null;
  //dropdownSettings={};
  constructor(public accountService: AccountService,public foruscareService: ForuscareService,public providerService: ServiceProviderService) { }

  ngOnInit() {
    this.camera_token=null;
    this.getAvailableAccounts();
    this.getScreeningCenters();
    /*this.dropdownSettings={ 
      singleSelection: false, 
      text:"Select screening centers",
      selectAllText:'Select All',
      unSelectAllText:'UnSelect All',
      enableSearchFilter: true,
      classes:""
    }; */
    
  }
  removeRow(index){
    this.dataObject.splice(index,1);
  }
  addNewRow(){
    if(this.validateFields()){
    this.dataObject.push({
      accountId:0,
      accountName:null,
      key:null,
      value:null,
      orgId:0,
      orgName:null,
      serviceProviderId:0,
      serviceProviderName:null
    });
    }
  }
  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                accountName: 'Select account',
                accountId: 0
              });
              
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification("Something went wrong", "danger");
        }
      });
  }
  getProviderKeyConfigurationByAcountId(){
  if(this.accountId>0){
  this.dataObject=[];
  this.providerService.getProviderKeyConfigurationByAcountId(this.accountId)
  .subscribe(response => {
    if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
      if (response.data != null) {
        if (response.data.length > 0) {
          response.data.forEach(element => {
            var tempObj={
              accountId:element.accountId,
              accountName:element.accountName,
              key:element.key,
              value:element.value,
              orgId:String(element.orgId),
              orgName:element.orgName,
              serviceProviderId:String(element.serviceProviderId),
              serviceProviderName:element.serviceProviderName
            }
            this.dataObject.push(tempObj);
            //this.getExistingProviderByOrgId(tempObj); //to get the providers list after load saved data
          });
            this.getExistingProviderByOrgId(this.dataObject[0]); //to get the providers list after load saved data
        }
        else{
          if(!this.resetPage){
          this.addNewRow();
          }
        }
      }
    }
    else{
      this.foruscareService.showNotification("Something went wrong", "danger");
    }
  });
  }
}
  getCameraToken(cameraId,cameraCode){
    if(cameraId==null || cameraId.trim().length==0 ){
      this.foruscareService.showNotification("Please enter camera id", "danger");
      return false;
    }
    if(cameraCode==null || cameraCode.trim().length==0){
      this.foruscareService.showNotification("Please enter camera code", "danger");
      return false;
    }
    this.camera_token="loading";
    this.providerService.getCameraToken(cameraId,cameraCode,this.accountId,(this.screeningCenters!=null&&this.screeningCenters.length>0)?this.screeningCenters[1].orgId:null)
    .subscribe(response=>{
      if(response.data!=null && response.errorCode==200){
        this.camera_token=response.data.camera_token;
      }
      else{
        this.foruscareService.showNotification("Failed to generate camera token", "danger");
      }
    });
  }
  validateEyenukAccount(accountId){
    var selectedAccount = this.accounts.filter(function(t){
      return accountId == t.id;
    });
    if(selectedAccount!=null && selectedAccount.length>0 && selectedAccount[0].id>0 && selectedAccount[0].name!=null && selectedAccount[0].name.toLowerCase().indexOf('eyenuk')>=0){
      this.showEyeNukPanel=true;
    }
    else{
      this.showEyeNukPanel=false;
    }
  }

  getScreeningCenters(){
    this.dataObject=[];
    if(this.accountId!=null && this.accountId>0){
    this.screeningCenters = [];
    this.accountService.screeningCentersByAccount(this.accountId)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                orgName: 'Select screening center',
                orgId: 0
              });
              this.screeningCenters=response.data;
              this.getProviderKeyConfigurationByAcountId();//load saved data
              /*
              response.data.forEach(element => {
                this.screeningCenters.push({id:element.orgId,itemName:element.orgName});
              });*/
              
            }
            else{
              this.screeningCenters.push({orgName: 'Select screening center',orgId: 0});
              if(!this.resetPage){
                this.addNewRow();
                }
            }
          }
        }
        else {
          this.foruscareService.showNotification("Something went wrong", "danger");
        }
      });
    }
    else{
      this.dataObject.splice(0);
    }
  }
  getExistingProviderByOrgId(itr){
    if(itr.orgId!=null){
      var temp=this.screeningCenters.filter(function(sc){
        return sc.orgId==itr.orgId
      })
      itr.orgName=temp[0].orgName;
    }
    this.providerService.getExistingProviderByOrgId(itr.orgId)
    .subscribe(response => {
      if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
        if (response.data != null) {
          if (response.data.length > 0) {
            response.data.unshift({
              name: 'Select service provider',
              id: 0
            });
            this.providers=response.data;
          }
        }
      }
      else {
        this.foruscareService.showNotification("Something went wrong", "danger");
      }
    });
  }
  setProviderName(itr){
    if(itr.serviceProviderId!=null){
      var temp=this.providers.filter(function(p){
        return p.id==itr.serviceProviderId
      })
      itr.serviceProviderName=temp[0].name;
    }
  }
  reset(){
    this.resetPage=true;
    this.getScreeningCenters();
    this.resetPage=false;
  }
  validateFields():boolean{
    var validToSave=true;
    this.dataObject.forEach(element => {if(element.key==null || element.key==""){
      this.foruscareService.showNotification("Key can not be blank","danger");
      validToSave=false;
      return false;
    }
    if(element.value==null || element.value==""){
      this.foruscareService.showNotification("Value can not be blank","danger");
      validToSave=false;
      return false;
    } 
    if(element.orgId==0 || element.orgId==null){
      this.foruscareService.showNotification("Select screening center","danger");
      validToSave=false;
      return false;
    }
    if(element.serviceProviderId==0 || element.serviceProviderId==null){
      this.foruscareService.showNotification("Select service provider","danger");
      validToSave=false;
      return false;
    }
    });
  return validToSave;
  }
  save(){
    if(this.validateFields()){
      if(this.accounts!=null){
        var tempAccId=this.accountId;
        var temp=this.accounts.filter(function(ac){
          return ac.accountId==tempAccId
        });
      }
      this.dataObject.forEach(element => {
        element.accountId=temp[0].accountId;
        element.accountName=temp[0].accountName;
      });
      /*var abc=JSON.parse(JSON.stringify(this.dataObject));
      abc.forEach(element => {
        var tempIds=element.screeningCenterIds.map(function(item){
          return item.id;
        });
        element.screeningCenterIds=tempIds;
      });*/
      this.providerService.addUpdateProviderKeyConfiguration(this.accountId,this.dataObject)
      .subscribe(response=>{
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          this.foruscareService.showNotification("Saved successfully","success");
        }
        else{
          this.foruscareService.showNotification("Something went wrong","danger");
        }
      })
    }
  }

}
